"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[161],{

/***/ 15738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/Breadcrumbs.js + 2 modules
var Breadcrumbs = __webpack_require__(7885);
// EXTERNAL MODULE: ./components/shopFeatures/wizard/constants.ts
var constants = __webpack_require__(45053);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(90387);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./reusable/icons/BreadCrumbsIcon.tsx

var SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "4",
        height: "8",
        viewBox: "0 0 4 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.5 7L0.5 4L3.5 1",
            stroke: "#D5D5D5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var BreadCrumbsIcon = (SvgComponent);

;// CONCATENATED MODULE: ./common/BreadCrumbsData.tsx
var BreadCrumbsData = {
    PrivacyPolicy: {
        links: [
            {
                title: "מדיניות הפרטיות",
                link: "/privacy-policy"
            }, 
        ]
    },
    TermsOfUse: {
        links: [
            {
                title: "תנאי שימוש",
                link: "/terms-of-use"
            }, 
        ]
    },
    Accessibility: {
        links: [
            {
                title: "הצהרת נגישות",
                link: "/accessibility"
            }, 
        ]
    },
    SiteMap: {
        links: [
            {
                title: "מפת אתר",
                link: "/sitemap"
            }
        ]
    },
    Recall: {
        links: [
            {
                title: "קריאות חוזרות",
                link: "/recall"
            }, 
        ]
    },
    Warranty: {
        links: [
            {
                title: "כתב אחריות",
                link: "/warranty"
            }, 
        ]
    },
    ServiceInstructions: {
        links: [
            {
                title: "הוראות שירות",
                link: "/service-instructions"
            }, 
        ]
    },
    WarrantyExtension: {
        links: [
            {
                title: "בדיקת תכולת הארכת אחריות",
                link: "/warranty-extension"
            }
        ]
    },
    SparePriceList: {
        links: [
            {
                title: "מחירון מוצרי תעבורה",
                link: "/spare-price-list"
            }, 
        ]
    },
    ColorCode: {
        links: [
            {
                title: "קוד צבע",
                link: "/color-code"
            }, 
        ]
    },
    Hamesayat: {
        links: [
            {
                title: "המסייעת",
                link: "/hamesayat"
            }, 
        ]
    },
    VideoTutorials: {
        links: [
            {
                title: "סרטוני הדרכה ותפעול",
                link: "/video-tutorials"
            }, 
        ]
    },
    ServicesCenters: {
        links: [
            {
                title: "מרכזי שירות",
                link: "/services-centers"
            }, 
        ]
    },
    ShowRooms: {
        links: [
            {
                title: "אולמות תצוגה",
                link: "/show-rooms"
            }, 
        ]
    },
    CarList: {
        links: [
            {
                title: "מחירון מכוניות",
                link: "/car-list"
            }, 
        ]
    },
    Insurance: {
        links: [
            {
                title: "ביטוח",
                link: "/insurance"
            }, 
        ]
    },
    CarFleets: {
        links: [
            {
                title: "ציי רכב",
                link: "/car-fleets"
            }, 
        ]
    },
    ContactUs: {
        links: [
            {
                title: "צרו קשר",
                link: "/contact-us"
            }, 
        ]
    },
    ServicePlans: {
        links: [
            {
                title: "תוכנית טיפול",
                link: "/service-plans"
            }, 
        ]
    }
};


// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./common/bit/utils/slugify.ts
var slugify = __webpack_require__(38730);
;// CONCATENATED MODULE: ./common/BreadCrumbs.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n\n  ",
        " {\n  }\n  ",
        " {\n    position: absolute;\n\n    ",
        ";\n    ",
        ";\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  max-width: 1400px;\n\n  ",
        " {\n    ",
        ";\n    ",
        ";\n    display: flex;\n    justify-content: flex-start;\n    padding-right: 20px;\n  }\n\n  ",
        " {\n    ",
        ";\n    ",
        ";\n  }\n  svg {\n    margin-top: 2px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 10px;\n  font-weight: 300;\n  letter-spacing: normal;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var SINGLE_SERVICE = "singleService";
var CONFIGURATOR = "configurator";
var StyledInnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BreadCrumbs__StyledInnerWrapper",
    componentId: "sc-e82e91a2-0"
})(_templateObject(), function(p) {
    return p.$page === SINGLE_SERVICE && "top: -20px";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "right: 25px";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$page !== CONFIGURATOR && "right: 50px;";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "top: -10px";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "right: 0px";
});
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BreadCrumbs__StyledWrapper",
    componentId: "sc-e82e91a2-1"
})(_templateObject1(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$page) !== CONFIGURATOR && "width: 100%;";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$page === CONFIGURATOR && "margin-top: -50px";
}, function(p) {
    return p.$page === CONFIGURATOR && (p === null || p === void 0 ? void 0 : p.$pathname) !== constants/* STEPS_EN.summary */.Ws.summary && "margin-right: 50px";
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$page !== CONFIGURATOR && "padding-right: 15px;";
}, function(p) {
    return p.$pathname === constants/* STEPS_EN.color */.Ws.color && "padding-right: 16px";
});
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* default */.Z).withConfig({
    displayName: "BreadCrumbs__StyledLink",
    componentId: "sc-e82e91a2-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.disable;
});
var BreadCrumbsWrapper = function(param) {
    var name = param.name, modelName = param.modelName, id = param.id, page = param.page, pathname = param.pathname;
    var router = (0,client_router.useRouter)();
    var carLinkUrl = function() {
        var carLink = "/model/[modelId]/[modelSlug]".replace("[modelId]", id.toString()).replace("[modelSlug]", (0,slugify/* default */.Z)(modelName));
        return carLink;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        $page: page,
        $pathname: pathname,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInnerWrapper, {
            $page: page,
            children: [
                BreadCrumbsData[name] && !modelName && !id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsIcon, {}),
                    "aria-label": "מיקומך בדפי האתר",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/",
                            children: "ראשי"
                        }),
                        BreadCrumbsData[name].links.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                color: "inherit",
                                href: item.link,
                                "aria-current": index === BreadCrumbsData[name].links.length - 1 && page !== SINGLE_SERVICE ? "page" : "step",
                                children: item.title
                            }, index);
                        }),
                        page === SINGLE_SERVICE && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: router.asPath,
                            "aria-current": "page",
                            children: router.query.serviceCenterSlug.toString().replace(/-/g, " ")
                        })
                    ]
                }),
                modelName && id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsIcon, {}),
                    "aria-label": "מיקומך בדפי האתר",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/",
                            children: "ראשי"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/models",
                            children: "לכל הדגמים"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: carLinkUrl(),
                            "aria-current": page !== CONFIGURATOR ? "page" : "step",
                            children: modelName
                        }),
                        page && page === CONFIGURATOR && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: router.asPath,
                            "aria-current": "page",
                            children: "התאמה אישית ורכישה"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var BreadCrumbs = (BreadCrumbsWrapper);


/***/ }),

/***/ 25384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports encodeImageUrl, seoKeys, emptySeo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12104);




var encodeImageUrl = function(baseUrl, params) {
    // Remove double slashes from the URL path (except for the protocol part)
    var correctedBaseUrl = baseUrl.replace(/([^:]\/)\/+/g, "$1");
    var queryString = Object.keys(params).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
    }).join("&");
    return "".concat(correctedBaseUrl, "?").concat(queryString);
};
var seoKeys = {
};
for(var key in seoKeys){
    seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}
var emptySeo = {
    title: " ",
    description: "",
    keywords: ""
};
var SeoMetaData = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
            title: data.title,
            description: data.description || "",
            additionalMetaTags: [
                {
                    name: "title",
                    content: data.title
                },
                {
                    name: "keywords",
                    content: data.keywords
                },
                {
                    name: "description",
                    content: data.description
                }, 
            ],
            openGraph: {
                title: data.title,
                description: data.description || "",
                images: data.image ? [
                    {
                        url: (0,_createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__/* .createImageApiUrl */ .h)(data.image.imageUrl),
                        alt: data.image.alt,
                        width: 1200,
                        height: 630
                    }, 
                ] : []
            },
            noindex: data.noIndex,
            nofollow: data.noIndex
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SeoMetaData));


/***/ }),

/***/ 74962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41810);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  /* display: flex; */\n  /* flex-wrap: wrap; */\n  /* gap: ",
        "px; */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  ",
        " {\n    width: 50%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 44px;\n  border: solid 1px transparent;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 5px;\n  background-color: ",
        ";\n  font-size: 16px;\n  direction: ",
        ";\n  cursor: pointer;\n  position: relative;\n  ",
        "\n\n  @media print {\n    display: none;\n    justify-content: flex-start;\n    box-shadow: none;\n    background-image: none !important;\n\n    span {\n      justify-content: flex-start;\n    }\n  }\n\n  b {\n    font-size: 1.5em;\n  }\n\n  span {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    inset: 0;\n    line-height: 1;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  border: 0;\n  margin: -1px;\n  padding: 0;\n  border-radius: 50%;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n\n  &:focus-visible + label {\n    border: 2px dashed white;\n    outline: 3px dashed #0e3487;\n    outline-offset: 2px;\n  }\n\n  :checked + ",
        " {\n    border-color: ",
        ";\n    color: ",
        ';\n    background-image: url("/battery-button.svg");\n    @media print {\n      display: block;\n      border: none;\n    }\n  }\n\n  :focus + ',
        " {\n    border-color: ",
        ";\n    color: ",
        ';\n    background-image: url("/battery-button.svg");\n    @media print {\n      display: block;\n      border: none;\n    }\n  }\n'
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SingleButtonSelection__StyledContainer",
    componentId: "sc-f3a656e3-0"
})(_templateObject(), function(props) {
    return props.$gap;
});
var StyledButtonWrap = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    displayName: "SingleButtonSelection__StyledButtonWrap",
    componentId: "sc-f3a656e3-1"
})(_templateObject1(), function(props) {
    return props.$itemsPerRow === "auto" ? "auto" : "calc(100% / ".concat(props.$itemsPerRow, " - ").concat(props.$gap, "px * (").concat(props.$itemsPerRow, " - 1) / ").concat(props.$itemsPerRow, ") ");
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledLabel = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    displayName: "SingleButtonSelection__StyledLabel",
    componentId: "sc-f3a656e3-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.$isBattery ? "ltr" : "rtl";
}, function(p) {
    return !p.$isBattery && "box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);";
}, function(p) {
    return p.$isBattery ? "\n    background-image:url('/battery-disabled.svg');\n    background-size:contain;\n    background-repeat:no-repeat;\n    border:none;\n    height: 0;\n    padding-bottom: calc( 100% * 59 / 232);\n    position: relative;\n\n  " : "background-image:none !important;";
});
var StyledRadio = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    displayName: "SingleButtonSelection__StyledRadio",
    componentId: "sc-f3a656e3-3"
})(_templateObject3(), StyledLabel, function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, StyledLabel, function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, function(param) {
    var theme = param.theme;
    return theme.colors.black;
});
var SingleButtonSelection = function(param) {
    var id = param.id, // title,
    items = param.items, onSelect = param.onSelect, isBattery = param.isBattery, customButton = param.customButton, // headlineComponent,
    selectedValue = param.selectedValue, className = param.className, _itemsPerRow = param.itemsPerRow, itemsPerRow = _itemsPerRow === void 0 ? 2 : _itemsPerRow, _gap = param.gap, gap = _gap === void 0 ? 0 : _gap;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(selectedValue || items[0].value), selectedButton = ref[0], setSelectedButton = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!items || !items.length) {
            return;
        }
        setSelectedButton(selectedValue || items[0].value);
    }, [
        items,
        selectedValue
    ]);
    var handleChange = function(value, index) {
        setSelectedButton(value);
        onSelect(value, index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContainer, {
        role: "radiogroup",
        "aria-labelledby": id,
        $gap: gap,
        className: className,
        children: items.map(function(item, index) {
            var ref;
            var radioId = "radio_".concat(id, "_").concat(item.value);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledButtonWrap, {
                tabIndex: -1,
                role: "presentation",
                focusRipple: true,
                $itemsPerRow: itemsPerRow,
                $gap: gap,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledRadio, {
                        "aria-label": "כפתור רדיו",
                        type: "radio",
                        name: id,
                        value: item.value,
                        id: radioId,
                        checked: item.value === selectedButton,
                        // disabled={!color.details.inStock}
                        onChange: function() {
                            handleChange(item.value, index);
                            setSelectedButton(item.value);
                        }
                    }),
                    customButton ? customButton(radioId, item.value === selectedButton, item, index) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLabel, {
                        $isBattery: isBattery,
                        htmlFor: radioId,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                            children: [
                                item.secondaryName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("b", {
                                    children: [
                                        item.secondaryName.toUpperCase(),
                                        "\xa0"
                                    ]
                                }),
                                (ref = item.name) === null || ref === void 0 ? void 0 : ref.toUpperCase()
                            ]
                        })
                    })
                ]
            }, "".concat(id, "-").concat(item.value, "-").concat(index));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SingleButtonSelection));


/***/ }),

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ createImageApiUrl; }
/* harmony export */ });
function createImageApiUrl(originalUrl) {
    var baseUrl = "https://www.mazda.co.il";
    var apiUrl = "https://api.mazda.co.il";
    if (!baseUrl || !apiUrl) {
        throw new Error("Environment variables ORIGIN and API_URL must be set");
    }
    // Extract the relative path from the original URL
    var relativePath = originalUrl.replace(apiUrl, "");
    // Construct the API URL
    return "".concat(baseUrl, "/api/ogimage").concat(encodeURI(relativePath));
}


/***/ }),

/***/ 62573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22318);
/* harmony import */ var common_bit_SingleButtonSelection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74962);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6089);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 10px;\n  color: #101010;\n  font-size: 20px;\n  font-weight: 300;\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  gap: 50px;\n  ",
        " {\n    justify-content: center;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  :focus {\n    outline: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  width: max-content;\n  align-items: start;\n  flex-direction: column;\n  p {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-radius: 100px;\n  width: 100%;\n  height: 4px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AreSelectionButtons__StyledWrapper",
    componentId: "sc-ae93634a-0"
})(_templateObject());
var StyledTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "AreSelectionButtons__StyledTitle",
    componentId: "sc-ae93634a-1"
})(_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledSingleButtonSelection = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(common_bit_SingleButtonSelection__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    displayName: "AreSelectionButtons__StyledSingleButtonSelection",
    componentId: "sc-ae93634a-2"
})(_templateObject2(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    displayName: "AreSelectionButtons__StyledButton",
    componentId: "sc-ae93634a-3"
})(_templateObject3());
var StyleCardButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AreSelectionButtons__StyleCardButton",
    componentId: "sc-ae93634a-4"
})(_templateObject4(), function(p) {
    return p.$activeButton ? p.theme.colors.black : "#616161";
});
var StyleLine = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AreSelectionButtons__StyleLine",
    componentId: "sc-ae93634a-5"
})(_templateObject5(), function(p) {
    return p.$activeButton ? p.theme.colors.black : "transparent";
});
var AreSelectionButtons = function(param) {
    var activeButton = param.activeButton, setActiveButton = param.setActiveButton, className = param.className, onSelectFunction = param.onSelectFunction;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTitle, {
                tabIndex: 0,
                children: "בחירת אזור"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSingleButtonSelection, {
                id: "era-selection",
                items: [
                    "הכל",
                    "צפון",
                    "מרכז",
                    "דרום"
                ].map(function(item, index) {
                    return {
                        value: index,
                        name: item
                    };
                }),
                itemsPerRow: "auto",
                selectedValue: activeButton,
                onSelect: function(code) {
                    setActiveButton(Number(code));
                    onSelectFunction ? onSelectFunction() : null;
                },
                customButton: function(radioId, isSelected, item) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
                        htmlFor: radioId,
                        $activeButton: isSelected,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyleCardButton, {
                            $activeButton: isSelected,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .TypographyRtl */ .UE, {
                                    variant: "body2",
                                    children: item.name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyleLine, {
                                    $activeButton: isSelected
                                })
                            ]
                        })
                    });
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AreSelectionButtons);


/***/ }),

/***/ 94316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89659);
/* harmony import */ var common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57402);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6089);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 300;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        " !important;\n  text-decoration: underline;\n  cursor: pointer;\n  p {\n    color: ",
        " !important;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var StyledText = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "CardRowText__StyledText",
    componentId: "sc-d731630f-0"
})(_templateObject(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$font) && "font-family: ".concat(p === null || p === void 0 ? void 0 : p.$font, ";");
}, function(p) {
    return (p === null || p === void 0 ? void 0 : p.$fontSize) && "font-size: ".concat(p === null || p === void 0 ? void 0 : p.$fontSize, "px;");
});
var StyledContent = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "CardRowText__StyledContent",
    componentId: "sc-d731630f-1"
})(_templateObject1());
var StyledLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "CardRowText__StyledLink",
    componentId: "sc-d731630f-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.saphire;
}, function(p) {
    return p.theme.colors.saphire;
});
var CardRowText = function(param) {
    var data = param.data, iconName = param.iconName, _link = param.link, link = _link === void 0 ? "" : _link, _iconInMobile = param.iconInMobile, iconInMobile = _iconInMobile === void 0 ? false : _iconInMobile, font = param.font, fontSize = param.fontSize, imageAlt = param.imageAlt, trackEvent = param.trackEvent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledContent, {
            onClick: function() {
                return trackEvent && trackEvent();
            },
            children: [
                iconName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: iconInMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(common_MediaQueries__WEBPACK_IMPORTED_MODULE_2__/* .Mobile */ .ij, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .StyledSvgIcon */ .vV, {
                            src: "/icons/".concat(iconName, ".svg"),
                            alt: imageAlt
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .StyledSvgIcon */ .vV, {
                        src: "/icons/".concat(iconName, ".svg"),
                        alt: imageAlt
                    })
                }),
                link !== "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLink, {
                    href: link,
                    rel: "noopener noreferrer",
                    target: "_blank",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledText, {
                        $font: font,
                        $fontSize: fontSize,
                        children: data
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledText, {
                    $font: font,
                    $fontSize: fontSize,
                    children: data
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardRowText);


/***/ }),

/***/ 66166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ map_DynamicMap; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/google-map-react/dist/index.modern.js + 1 modules
var index_modern = __webpack_require__(76725);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./components/mapPages/map/utils/mapOptions.ts
var mapOptions = {
    // mapId: "5ce3117565d8f466",
    fullscreenControl: false
};

;// CONCATENATED MODULE: ./components/mapPages/map/DynamicMap.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 148px;\n  margin-bottom: 20px;\n  position: relative;\n  background: ",
        ";\n  svg {\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n    path {\n      outline: none;\n    }\n  }\n  ",
        " {\n    width: 100%;\n    height: 100%;\n    margin-top: 0;\n    margin-bottom: 0;\n    background-image: linear-gradient(to right, #e4eef8 80%, white);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var apiKey = "AIzaSyAIFH94qNjJhJpZsNuTJHk_kxYSBxMrzY4";
var StyledMapContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "DynamicMap__StyledMapContainer",
    componentId: "sc-48e31f1-0"
})(_templateObject(), function(p) {
    return p.theme.colors.nonExistentLightBlue;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var DynamicMap = function(param) {
    var setMaps = param.setMaps, setMap = param.setMap;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMapContainer, {
        "aria-label": "מפה, ניתן לנווט עם חצי המקלדת",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* default */.ZP, {
            bootstrapURLKeys: {
                key: apiKey,
                language: "iw",
                libraries: [
                    "geometry"
                ]
            },
            options: mapOptions,
            defaultCenter: {
                lat: 31.739798850747462,
                lng: 34.557425805228085
            },
            defaultZoom: 7,
            yesIWantToUseGoogleMapApiInternals: true,
            onGoogleApiLoaded: function(param) {
                var map = param.map, maps = param.maps;
                setMap(map);
                setMaps(maps);
            }
        })
    });
};
/* harmony default export */ var map_DynamicMap = (DynamicMap);


/***/ }),

/***/ 95887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sf": function() { return /* binding */ MapContextProvider; },
  "fx": function() { return /* binding */ useMapContext; }
});

// UNUSED EXPORTS: MapContext

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/mapPages/map/utils/createStationMarkers.tsx
var prevMarker = null;
var createStationMarkers = function(maps, markers, map, onItemClick) {
    var regularMarker = {
        url: "/icons/location-marker.svg",
        size: new maps.Size(53.3, 66.3),
        origin: new maps.Point(0, 0),
        anchor: new maps.Point(17, 25),
        scaledSize: new maps.Size(30, 30)
    };
    var selectedMaker = {
        url: "/icons/location-marker-selected.svg",
        size: new maps.Size(53.3, 66.3),
        origin: new maps.Point(0, 0),
        anchor: new maps.Point(17, 25),
        scaledSize: new maps.Size(30, 30)
    };
    // this is responsible for infoWindow (we dont use it));
    // const infoWindow = new maps.InfoWindow()
    var bounds = new maps.LatLngBounds();
    var markersArray = [];
    markers.map(function(marker) {
        var ref, ref1;
        var position = {
            lat: marker === null || marker === void 0 ? void 0 : (ref = marker.location) === null || ref === void 0 ? void 0 : ref.latitude,
            lng: marker === null || marker === void 0 ? void 0 : (ref1 = marker.location) === null || ref1 === void 0 ? void 0 : ref1.longitude
        };
        var markerObject = new maps.Marker({
            position: position,
            icon: regularMarker,
            type: "station",
            optimized: false,
            title: marker.name,
            zIndex: 1,
            map: map,
            tagId: marker.id
        });
        markersArray.push(markerObject);
        bounds.extend(position);
        markerObject.addListener("click", function() {
            // infoWindow.close()
            markerObject.setIcon(selectedMaker);
            onItemClick(marker, true);
            // marker
            if (prevMarker !== markerObject && prevMarker !== null) {
                prevMarker.setIcon(regularMarker);
            }
            prevMarker = markerObject;
        // open infoWindow (we don't use it here)):
        // infoWindow.open(markerObject.getMap(), markerObject)
        });
        markerObject.setIcon(regularMarker);
    // infoWindow.addListener("closeclick", () => {
    //   if (prevMarker) {
    //     prevMarker.setIcon(regularMarker)
    //   }
    // })
    });
    map.fitBounds(bounds);
    var zoom = map.getZoom();
    map.setZoom(zoom > 15 ? 15 : zoom);
    return markersArray;
};

;// CONCATENATED MODULE: ./components/mapPages/map/MapContext.tsx



// 1. create context + 2.naming context shows in component tree
var MapContext = /*#__PURE__*/ (0,react.createContext)(null);
MapContext.displayName = "MapContext";
// 3. context provider:
function MapContextProvider(param) {
    var children = param.children, itemList = param.itemList;
    // keep track of `selectedItems` somehow
    // stores states:
    var ref = (0,react.useState)(itemList), stores = ref[0], setStores = ref[1];
    var ref1 = (0,react.useState)(itemList), alphabetOrderStores = ref1[0], setAlphabetOrderStores = ref1[1];
    var ref2 = (0,react.useState)(itemList), filterStores = ref2[0], setFilterStores = ref2[1];
    var ref3 = (0,react.useState)(null), selectedStore = ref3[0], setSelectedStore = ref3[1];
    // map states:
    var ref4 = (0,react.useState)(null), map = ref4[0], setMap = ref4[1];
    var ref5 = (0,react.useState)(null), maps = ref5[0], setMaps = ref5[1];
    var ref6 = (0,react.useState)([]), activeMarkers = ref6[0], setActiveMarkers = ref6[1];
    // clear markers function:
    var clearMarkers = (0,react.useCallback)(function() {
        activeMarkers.forEach(function(marker) {
            marker.setMap(null);
        });
    }, [
        activeMarkers
    ]);
    // on showRoom click function:
    var onStoreClick = function(store) {
        var isMarker = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        setSelectedStore(store);
        if (map && maps && store && !isMarker) {
            map.setCenter({
                lat: store.location.latitude,
                lng: store.location.longitude
            });
            // map.setZoom(15)
            var marker = activeMarkers.find(function(item) {
                return item.tagId === store.id;
            });
            if (marker) {
                maps.event.trigger(marker, "click");
            }
        }
    };
    // creating the map markers:
    (0,react.useEffect)(function() {
        if (!filterStores.length || !map || !maps) return;
        clearMarkers();
        setActiveMarkers(createStationMarkers(maps, filterStores, map, onStoreClick));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filterStores,
        map,
        maps
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MapContext.Provider, {
        value: {
            selectedStore: selectedStore,
            setSelectedStore: setSelectedStore,
            stores: stores,
            setStores: setStores,
            setMap: setMap,
            setMaps: setMaps,
            onStoreClick: onStoreClick,
            filterStores: filterStores,
            setFilterStores: setFilterStores,
            setAlphabetOrderStores: setAlphabetOrderStores,
            alphabetOrderStores: alphabetOrderStores
        },
        children: children
    });
}
function useMapContext() {
    var context = (0,react.useContext)(MapContext);
    if (!context) {
        throw new Error("useMyContext must be used under MyContextProvider");
    }
    return context;
}


/***/ }),

/***/ 1719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bg": function() { return /* binding */ Areas; },
/* harmony export */   "Le": function() { return /* binding */ locationFilterListService; },
/* harmony export */   "Z3": function() { return /* binding */ cityFilterList; },
/* harmony export */   "_D": function() { return /* binding */ locationFilterListShowRooms; },
/* harmony export */   "kB": function() { return /* binding */ isInHesderFilterList; },
/* harmony export */   "s0": function() { return /* binding */ ToggleButtons; }
/* harmony export */ });
var ToggleButtons;
(function(ToggleButtons) {
    ToggleButtons[ToggleButtons["CLOSE_TO_ME"] = 0] = "CLOSE_TO_ME";
    ToggleButtons[ToggleButtons["AREAS"] = 1] = "AREAS";
})(ToggleButtons || (ToggleButtons = {}));
var Areas;
(function(Areas) {
    Areas[Areas["ALL"] = 0] = "ALL";
    Areas[Areas["NORTH"] = 1] = "NORTH";
    Areas[Areas["CENTER"] = 2] = "CENTER";
    Areas[Areas["SOUTH"] = 3] = "SOUTH";
})(Areas || (Areas = {}));
var locationFilterListShowRooms = function(itemList, selectedAreaId, toggleIndex) {
    if (toggleIndex === ToggleButtons.CLOSE_TO_ME) {
        return itemList;
    }
    if (selectedAreaId === Areas.ALL) {
        return itemList;
    }
    return itemList.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.areaId) === selectedAreaId;
    });
};
var locationFilterListService = function(itemList, selectedAreaId, toggleIndex) {
    if (toggleIndex === ToggleButtons.CLOSE_TO_ME) {
        return itemList;
    }
    if (selectedAreaId === Areas.ALL) {
        return itemList;
    }
    return itemList.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.areaId) === selectedAreaId;
    });
};
var cityFilterList = function(itemList, cityId) {
    if (cityId === "" || cityId === null) {
        return itemList;
    }
    return itemList.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.city) === cityId;
    });
};
var isInHesderFilterList = function(itemList, inHesder) {
    if (!inHesder) {
        return itemList;
    }
    return itemList.filter(function(item) {
        return item === null || item === void 0 ? void 0 : item.isInHesder;
    });
};


/***/ }),

/***/ 17942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

// https://github.com/codegeous/react-component-depot/blob/master/src/pages/HooksDemo/index.js
var useGeoLocation = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        loaded: false,
        lat: null,
        lng: null,
        error: {
            code: "",
            message: ""
        }
    }), location = ref[0], setLocation = ref[1];
    var onSuccess = function(location) {
        setLocation({
            loaded: true,
            lat: location.coords.latitude,
            lng: location.coords.longitude,
            error: {
                code: "",
                message: ""
            }
        });
    };
    var onError = function(error) {
        setLocation({
            loaded: true,
            lat: null,
            lng: null,
            error: {
                code: error.code,
                message: error.message
            }
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!("geolocation" in navigator)) {
            onError({
                code: 0,
                message: "Geolocation not supported"
            });
        }
        navigator.geolocation.getCurrentPosition(onSuccess, onError);
    }, []);
    return location;
};
/* harmony default export */ __webpack_exports__["Z"] = (useGeoLocation);


/***/ }),

/***/ 70498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var common_bit_SingleButtonSelection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74962);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6089);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    width: 320px;\n    margin: 0 auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-grow: 1;\n  flex-direction: row;\n  width: 100%;\n  gap: 0px;\n  background-color: ",
        ";\n  border: 2px solid ",
        ";\n  border-radius: 3px;\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  :focus {\n    outline: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 0px;\n  background-color: ",
        ";\n\n  p {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "TwoToggleButtons__StyledWrapper",
    componentId: "sc-a9947446-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledSingleButtonSelection = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(common_bit_SingleButtonSelection__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    displayName: "TwoToggleButtons__StyledSingleButtonSelection",
    componentId: "sc-a9947446-1"
})(_templateObject1(), function(p) {
    return p.theme.colors.saphire;
}, function(p) {
    return p.theme.colors.saphire;
});
var StyledButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    displayName: "TwoToggleButtons__StyledButton",
    componentId: "sc-a9947446-2"
})(_templateObject2());
var StyleCardButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "TwoToggleButtons__StyleCardButton",
    componentId: "sc-a9947446-3"
})(_templateObject3(), function(p) {
    return p.$activeButton ? p.theme.colors.saphire : p.theme.colors.white;
}, function(p) {
    return p.$activeButton ? p.theme.colors.white : p.theme.colors.saphire;
});
var TwoToggleButtons = function(param) {
    var activeButton = param.activeButton, setActiveButton = param.setActiveButton, optionsList = param.optionsList, toggleId = param.toggleId, className = param.className, onSelect = param.onSelect;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSingleButtonSelection, {
            id: toggleId,
            items: optionsList.map(function(item, index) {
                return {
                    value: index,
                    name: item
                };
            }),
            itemsPerRow: 2,
            selectedValue: activeButton,
            onSelect: function(code) {
                setActiveButton(Number(code));
                if (onSelect) {
                    onSelect === null || onSelect === void 0 ? void 0 : onSelect();
                }
            },
            customButton: function(radioId, isSelected, item) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
                    htmlFor: radioId,
                    $activeButton: isSelected,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyleCardButton, {
                        $activeButton: isSelected,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .TypographyRtl */ .UE, {
                            variant: "body2",
                            children: item.name
                        })
                    })
                });
            }
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TwoToggleButtons);


/***/ }),

/***/ 2423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var theme_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22038);






var SvgComponent = function(_param) {
    var _color = _param.color, color = _color === void 0 ? theme_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].disable */ .Z.disable : _color, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "color"
    ]);
    var w = 35;
    var h = 35;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 ".concat(w, " ").concat(h),
        width: w,
        height: h,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "35",
                height: "35",
                fill: "#f5f5f50"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M24.25 11L10.75 24.5",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M24.25 24.25L10.75 10.75",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);


/***/ }),

/***/ 66395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52663);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var reusable_icons_CloseIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2423);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);
/* harmony import */ var theme_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22038);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6089);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .MuiDialog-paper {\n    width: ",
        ";\n    border-radius: 8px;\n    background-color: ",
        ";\n    padding: 20px;\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n    box-shadow: ",
        ";\n    max-width: ",
        " !important;\n  }\n  /* mobile size: */\n  ",
        " {\n    .MuiDialog-paper {\n      ",
        "\n    }\n\n    .MuiDialog-container {\n      height: 100%;\n      max-height: 100vh;\n      max-width: 560px !important;\n      margin: auto;\n    }\n    .MuiDialog-paperScrollBody {\n      margin: auto;\n    }\n  }\n  /* desktop size: */\n  ",
        " {\n    .MuiDialog-paper {\n      max-height: none;\n      overflow: initial;\n    }\n  }\n  ",
        " {\n    .mobile-margin {\n      margin: 34px 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  form {\n    height: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  z-index: 2;\n  ",
        " {\n    padding: 0px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  font-size: 24px;\n  font-weight: 400;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  max-width: 400px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: ",
        ";\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n  /* if children */\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var StyledDialog = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "ClassicPopUp__StyledDialog",
    componentId: "sc-9c187a67-0"
})(_templateObject(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$hasError) ? "560px" : "calc(100% - 40px)";
}, function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.$padding ? p.$padding : "20px";
}, function(p) {
    return p.$padding ? p.$padding : "20px";
}, function(p) {
    return p.theme.boxShadows.cardShadow;
}, function(p) {
    return p.$narrow ? "350px" : "650px";
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return (p === null || p === void 0 ? void 0 : p.$hasError) && "width: 316px;";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ClassicPopUp__StyledWrapper",
    componentId: "sc-9c187a67-1"
})(_templateObject1());
var StyledIconButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    displayName: "ClassicPopUp__StyledIconButton",
    componentId: "sc-9c187a67-2"
})(_templateObject2(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "ClassicPopUp__StyledTitle",
    componentId: "sc-9c187a67-3"
})(_templateObject3());
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "ClassicPopUp__StyledSubtitle",
    componentId: "sc-9c187a67-4"
})(_templateObject4());
var StyledPopUpTop = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ClassicPopUp__StyledPopUpTop",
    componentId: "sc-9c187a67-5"
})(_templateObject5(), function(p) {
    return p.$hasError ? "none" : "flex";
}, function(p) {
    return p.$hasChildren && "margin-bottom: 20px;";
});
var ClassicPopUp = function(param) {
    var open = param.open, setOpen = param.setOpen, onClose = param.onClose, children = param.children, icon = param.icon, title = param.title, text = param.text, hasError = param.hasError, className = param.className, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? true : _backgroundColor, _withDivider = param.withDivider, withDivider = _withDivider === void 0 ? false : _withDivider, _narrow = param.narrow, narrow = _narrow === void 0 ? false : _narrow, dialogClass = param.dialogClass, padding = param.padding, arialabelledby = param.arialabelledby, invertCloseIcon = param.invertCloseIcon;
    var handleClose = function() {
        if (setOpen) {
            setOpen(false);
        }
        if (onClose) {
            onClose();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledDialog, {
        open: open,
        onClose: handleClose,
        scroll: "body",
        className: className,
        $backgroundColor: backgroundColor,
        $narrow: narrow,
        classes: {
            paper: dialogClass
        },
        "aria-modal": true,
        tabIndex: -1,
        "aria-labelledby": arialabelledby ? arialabelledby : title,
        $hasError: hasError,
        $padding: padding,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledIconButton, {
                onClick: handleClose,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(reusable_icons_CloseIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    width: 35,
                    height: 35,
                    "aria-label": "close window",
                    color: invertCloseIcon ? "white" : undefined
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledPopUpTop, {
                        $hasError: hasError,
                        $hasChildren: children !== undefined || withDivider,
                        children: [
                            icon && icon,
                            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTitle, {
                                children: title
                            }),
                            text && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubtitle, {
                                children: text
                            })
                        ]
                    }),
                    withDivider && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_4__/* .StyledDividerH */ .aV, {
                        $color: theme_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"].darkGrey */ .Z.darkGrey,
                        $width: 0.5,
                        $radius: 3,
                        $mb: "20px"
                    }),
                    children
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ClassicPopUp);


/***/ }),

/***/ 28114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22318);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57833);
/* harmony import */ var _ClassicPopUp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66395);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  /* margin-top: 20px; */\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "ErrorLocationPopUp__StyledText",
    componentId: "sc-b390dd8c-0"
})(_templateObject());
var ErrorLocationPopUp = function(param) {
    var open = param.open, setOpen = param.setOpen, setUserHasSeenPopUpError = param.setUserHasSeenPopUpError;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ClassicPopUp__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        open: open,
        setOpen: setOpen,
        title: "המיקום הנוכחי לא זמין",
        onClose: function() {
            return setUserHasSeenPopUpError(true);
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledText, {
            children: "המיקום הנוכחי לא זמין. יש לאשר גישה לגבי המיקום שלך"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorLocationPopUp);


/***/ }),

/***/ 63358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13328);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  position: relative;\n  height: 150px;\n  ",
        " {\n    height: 270px;\n    ",
        ";\n  }\n  img {\n    object-fit: cover;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ImageContainer__StyledImageContainer",
    componentId: "sc-4c5af28c-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$collapseOpen && "margin-top: 63px";
});
var ImageContainer = function(param) {
    var src = param.src;
    var collapseOpen = (0,store__WEBPACK_IMPORTED_MODULE_3__/* .useTypedSelector */ .ix)(function(state) {
        return state.collapseLayout;
    }).collapseOpen;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImageContainer, {
        $collapseOpen: collapseOpen,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            src: src,
            layout: "fill",
            priority: true,
            alt: "page-cover-img",
            role: "presentation",
            "aria-hidden": "true"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageContainer);


/***/ }),

/***/ 45732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43832);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var common_BreadCrumbs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15738);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6089);
/* harmony import */ var _ImageContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63358);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  padding-top: ",
        "px;\n  flex-direction: column;\n  background-color: ",
        ";\n  ",
        " {\n    padding-top: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-bottom: 60px;\n  flex-direction: column;\n  width: 100%;\n  padding-right: 20px;\n  padding-left: 20px;\n  ",
        " {\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 80px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 40px 20px;\n  padding-bottom: ",
        ";\n  ",
        " {\n    padding: 40px 20px 20px;\n    max-width: 800px;\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: right;\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: right;\n  margin-top: 10px;\n  ",
        " {\n    margin-top: 20px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var StyledPageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "InnerPageWrapper__StyledPageWrapper",
    componentId: "sc-df466e4e-0"
})(_templateObject(), theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .HEADER_HEIGHT_M */ .Gi, function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .HEADER_HEIGHT_D */ .gw);
var StyledPageWrap = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "InnerPageWrapper__StyledPageWrap",
    componentId: "sc-df466e4e-1"
})(_templateObject1());
var StyledContentWrap = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "InnerPageWrapper__StyledContentWrap",
    componentId: "sc-df466e4e-2"
})(_templateObject2(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "InnerPageWrapper__StyledHeader",
    componentId: "sc-df466e4e-3"
})(_templateObject3(), function(p) {
    return "".concat(p.$paddingBottom && p.$paddingBottom, "px");
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return "".concat(p.$paddingBottom && p.$paddingBottom, "px !important");
});
var StyledHeadline = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).attrs({
    variant: "h2",
    component: "h1"
}).withConfig({
    displayName: "InnerPageWrapper__StyledHeadline",
    componentId: "sc-df466e4e-4"
})(_templateObject4(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    displayName: "InnerPageWrapper__StyledSubtitle",
    componentId: "sc-df466e4e-5"
})(_templateObject5(), function(p) {
    return p.theme.breakpoints.up("md");
});
var InnerPageWrapper = function(param) {
    var imgUrl = param.imgUrl, title = param.title, subtitle = param.subtitle, children = param.children, breadCrumbName = param.breadCrumbName, page = param.page, paddingBottom = param.paddingBottom, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPageWrapper, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledPageWrap, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ImageContainer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    src: imgUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(common_BreadCrumbs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    name: breadCrumbName,
                    page: page
                }),
                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledHeader, {
                    $paddingBottom: paddingBottom,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledHeadline, {
                            children: [
                                " ",
                                title,
                                " "
                            ]
                        }),
                        subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubtitle, {
                            dangerouslySetInnerHTML: {
                                __html: subtitle
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContentWrap, {
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InnerPageWrapper);


/***/ })

}]);